import script from "./CommentsTab.vue?vue&type=script&setup=true&lang=ts"
export * from "./CommentsTab.vue?vue&type=script&setup=true&lang=ts"

import "./CommentsTab.vue?vue&type=style&index=0&id=703ccf82&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-703ccf82"]])

export default __exports__